// Mock data for ZD Consulting (正大律师事务所) bilingual website
// NOTE: All data below is MOCKED (frontend only). Contact form does not persist.

import {
  Building2, Users, FileText, BadgeCheck, Plane, Scale,
  Calculator, Car, ShieldCheck, Home, Container, Truck
} from "lucide-react";

export const company = {
  name: "ZD Consulting",
  nameZh: "正大律师事务所",
  logo: "/images/logo.png",
  phone: "55 2194 5826",
  phoneRaw: "5521945826",
  email: "info@grupozdmx.com",
  address: "Lago Alberto 320, Granada, Miguel Hidalgo, 11520 Ciudad de México, CDMX",
  social: {
    facebook: "https://www.facebook.com/profile.php?id=100088398054187",
    instagram: "https://www.instagram.com/zdconsultingmexico/",
    xiaohongshu: "https://www.xiaohongshu.com/user/profile/63750ab4000000001f01ccd9"
  }
};

export const services = [
  {
    id: "constitucion-empresas",
    icon: Building2,
    image: "/images/srv-constitucion.jpg",
    es: { title: "Constitución de empresas", desc: "Creamos y damos de alta tu empresa en México con total respaldo legal." },
    zh: { title: "公司注册", desc: "为您在墨西哥合法设立并注册公司，全程专业支持。" }
  },
  {
    id: "recursos-humanos",
    icon: Users,
    image: "/images/srv-recursos.jpg",
    es: { title: "Recursos humanos", desc: "Gestión de nóminas, contrataciones y cumplimiento laboral." },
    zh: { title: "人力资源", desc: "薪资管理、员工招聘与劳动合规服务。" }
  },
  {
    id: "tramites-sat",
    icon: FileText,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f",
    es: { title: "Trámites ante el SAT", desc: "Altas, declaraciones y trámites fiscales ante el SAT." },
    zh: { title: "SAT 税务手续", desc: "税务登记、申报及各类税务事务办理。" }
  },
  {
    id: "registro-marca",
    icon: BadgeCheck,
    image: "/images/srv-marca.jpg",
    es: { title: "Registro de marca, diseños y patentes", desc: "Protege tu marca, diseños industriales y patentes." },
    zh: { title: "商标、设计与专利注册", desc: "保护您的商标、工业设计与专利权利。" }
  },
  {
    id: "tramite-migratorio",
    icon: Plane,
    image: "/images/srv-migratorio.jpg",
    es: { title: "Trámites migratorios, VISA, residencias", desc: "Todos los trámites de migración, visas y residencias." },
    zh: { title: "移民手续、签证、居留", desc: "办理各类移民、签证及居留手续。" }
  },
  {
    id: "asesoria-juridica",
    icon: Scale,
    image: "/images/srv-juridica.jpg",
    es: { title: "Asesoría Jurídica", desc: "Abogados y asesores para todos tus asuntos legales." },
    zh: { title: "法律咨询", desc: "律师与顾问为您处理各类法律事务。" }
  },
  {
    id: "asesoria-fiscal",
    icon: Calculator,
    image: "/images/srv-fiscal.jpg",
    es: { title: "Asesoría Fiscal y Contable", desc: "Contabilidad, planeación fiscal y cumplimiento." },
    zh: { title: "财税与会计咨询", desc: "会计核算、税务筹划与合规服务。" }
  },
  {
    id: "gestion-vehicular",
    icon: Car,
    image: "/images/srv-vehicular.jpg",
    es: { title: "Gestión Vehicular", desc: "Trámites, placas y gestión de vehículos." },
    zh: { title: "车辆管理", desc: "车辆手续、车牌及相关管理服务。" }
  },
  {
    id: "seguros",
    icon: ShieldCheck,
    image: "/images/srv-seguros.jpg",
    es: { title: "Seguros", desc: "Pólizas de seguro para personas y empresas." },
    zh: { title: "保险", desc: "为个人与企业提供多种保险方案。" }
  },
  {
    id: "inmobiliario",
    icon: Home,
    image: "/images/srv-inmobiliario.jpg",
    es: { title: "Inmobiliario: Local y vivienda", desc: "Compra, renta y gestión de locales y viviendas." },
    zh: { title: "房地产：商铺与住房", desc: "商铺与住宅的买卖、租赁及管理。" }
  },
  {
    id: "aduanero",
    icon: Container,
    image: "/images/srv-aduanero.jpg",
    es: { title: "Trámite y gestión aduanero", desc: "Gestión aduanera y búsqueda de mercancía en China." },
    zh: { title: "海关手续与管理", desc: "海关事务办理及中国货源采购服务。" }
  },
  {
    id: "logistica",
    icon: Truck,
    image: "/images/srv-logistica.jpg",
    es: { title: "Logística terrestre, aérea y marítima", desc: "Carga consolidada de China a México por tierra, aire y mar." },
    zh: { title: "陆运 · 空运 · 海运物流", desc: "中国至墨西哥集运，陆运、空运与海运全覆盖。" }
  }
];

export const stats = [
  { value: 12, suffix: "+", es: "Servicios integrales", zh: "综合服务" },
  { value: 500, suffix: "+", es: "Clientes satisfechos", zh: "满意客户" },
  { value: 20, suffix: "+", es: "Años de experiencia", zh: "年经验" },
  { value: 2, suffix: "", es: "Idiomas · 中文/ES", zh: "双语服务" }
];

export const heroImages = {
  hero: "/images/hero.jpg",
  about: "/images/about.jpg",
  skyline: "/images/skyline.jpg"
};

export const translations = {
  es: {
    nav: { home: "Inicio", about: "Nosotros", services: "Servicios", why: "Por qué", contact: "Contacto", cta: "Contáctanos" },
    hero: {
      badge: "Consultoría internacional en México",
      title1: "Asesoría legal y empresarial",
      title2: "para la comunidad china en México",
      subtitle: "En ZD Consulting acompañamos a personas y empresas con servicios jurídicos, fiscales, migratorios y de logística. Tus asuntos, en las mejores manos.",
      ctaPrimary: "Solicita asesoría",
      ctaSecondary: "Ver servicios"
    },
    about: {
      tag: "¿Quiénes Somos?",
      title: "Tu socio de confianza en México",
      p1: "ZD Consulting es una empresa consultora internacional que presta servicios de asesoramiento a nivel empresarial y particular, dirigido principalmente a la comunidad china en México.",
      p2: "Constituimos empresas y damos de alta como autónomo en México. Todos los trámites de migración puedes verlos con nosotros.",
      p3: "Nuestros abogados y asesores estarán encantados de poder ayudarles en sus asuntos.",
      points: ["Atención bilingüe 中文 / Español", "Abogados y asesores certificados", "Acompañamiento de principio a fin"]
    },
    services: { tag: "Nuestros Servicios", title: "Soluciones integrales a tu medida", subtitle: "Todo lo que tu proyecto necesita, en un solo lugar.", cta: "Saber más" },
    why: { tag: "Por qué elegirnos", title: "Experiencia que genera confianza" },
    contact: {
      tag: "Contacto", title: "Hablemos de tu proyecto", subtitle: "Nuestros asesores están listos para ayudarte.",
      name: "Nombre", email: "Correo electrónico", phone: "Teléfono", message: "Mensaje",
      send: "Enviar mensaje", success: "¡Gracias por tu mensaje! Te contactaremos pronto.",
      infoTitle: "Información de contacto", addressLabel: "Dirección", phoneLabel: "Teléfono", emailLabel: "Correo"
    },
    footer: { rights: "Todos los derechos reservados.", tagline: "Consultoría legal y empresarial · 墨西哥" }
  },
  zh: {
    nav: { home: "首页", about: "关于我们", services: "服务项目", why: "选择理由", contact: "联系我们", cta: "联系我们" },
    hero: {
      badge: "墨西哥国际咨询公司",
      title1: "专业法律与商业咨询",
      title2: "服务墨西哥华人社区",
      subtitle: "正大为个人与企业提供法律、财税、移民及物流等全方位咨询服务。您的事务，交给最专业的团队。",
      ctaPrimary: "预约咨询",
      ctaSecondary: "查看服务"
    },
    about: {
      tag: "关于我们",
      title: "您在墨西哥值得信赖的伙伴",
      p1: "正大是一家国际咨询公司，主要面向墨西哥华人社区，提供商业与个人层面的咨询服务。",
      p2: "我们可在墨西哥设立公司并注册个体经营，所有移民手续均可由我们协助办理。",
      p3: "我们的律师与顾问将竭诚为您处理各项事务。",
      points: ["中文 / 西班牙语双语服务", "持证律师与专业顾问", "从头到尾全程陪同"]
    },
    services: { tag: "服务项目", title: "量身定制的一站式解决方案", subtitle: "您的项目所需，尽在一处。", cta: "了解更多" },
    why: { tag: "选择理由", title: "值得信赖的丰富经验" },
    contact: {
      tag: "联系我们", title: "聊聊您的需求", subtitle: "我们的顾问随时为您服务。",
      name: "姓名", email: "电子邮箱", phone: "电话", message: "留言",
      send: "发送信息", success: "感谢您的留言！我们会尽快与您联系。",
      infoTitle: "联系方式", addressLabel: "地址", phoneLabel: "电话", emailLabel: "邮箱"
    },
    footer: { rights: "版权所有。", tagline: "法律与商业咨询 · 墨西哥" }
  }
};
